import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    Grid,
    ClickAwayListener,
    Tooltip,
    MenuItem,
    MenuList,
} from '@material-ui/core';
import CustomizedSearchInput from 'mdoc/utils/CustomizedSearchInput';
import { dictionary, getPermissions } from 'mdoc/admin/axios';
import { applyList } from 'mdoc/admin/axios/content';
import CustomizedTable from 'mdoc/utils/table';
import Toast from 'mdoc/utils/toast';
import { dateFormat } from 'mdoc/utils';


const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    tip: {
        background: '#2096fb',
    },
    title: {
        marginLeft: '-20px'
    },
    item: {
        color: '#ffffff',
    }
});
class Content_Read extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [
        ],
        detailData: [],
        loading: false,
        permissions: [],
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            count: 0,
            sidx: '',
            sord: ''
        },
        dictWord: {
            'application_import': '',
            'department': '',
            'responsible_person': '',
            'published_user': '',
            'reader': '',
            'upload_date': '',
            'management': '',
            'content_add': '',
            'reader_edit': '',
            'cancel': '',
            'reader_detail': '',
            'user_code': '',
            'contact_person_name': '',
            'department_name': '',
            'mail_address': '',
            'set_lang': '',
            'device_control': '',
            'add_delete': '',
            'close': '',
            'details': '',
            'valid': '',
            'invalid': '',
            'add_record': '',
            'delete_record': '',
            'japanese': '',
            'chinese': '',
            'english': '',
            'modify_record': '',
            'published_department': '',
            'status': '',
            'upload_wait': '',
            'upload_completed': '',
            category: ''
        },
        search: '',
        dialogOpen: false,
        langIdData: [],
        TooltipOpen: [],
        docMstBookCategoryList: null,
        categoryName: '',
    }
    componentWillMount() {
        let dict = {}
        dictionary(this.state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
        this.fetch(this.state.pagination);
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        this.setState({
            permissions: permissions
        });
    }


    fetch = (params = {}) => {
        this.setState({ loading: true })
        applyList({
            ...params,
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            if (data.results === undefined) {
                Toast.info(this.state.dictWord.msg_error_record_not_found)
            }
            for (let i in data.results) {
                data.results[i]['name'] = data.results[i].docTblAdminUser.name;
            }
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }

    handleTableChange = (event, pagination) => {
        this.fetch({
            searchKeyword: this.state.search,
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            searchKeyword: this.state.search,
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    };
    handleSearch(keyWords) {
        this.setState({
            search: keyWords
        }, () => {
            this.fetch({
                searchKeyword: keyWords,
                pageNumber: this.state.pagination.pageNumber,
                pageSize: this.state.pagination.pageSize,
                sidx: this.state.pagination.sidx,
                sord: this.state.pagination.sord,
            })
        });
    }

    goto(item) {
        this.props.history.push('/admin/content/contentupload/' + item.id);
    }

    handleTooltipOpens = (id) => event => {
        let TooltipOpen = this.state.TooltipOpen;
        if (!TooltipOpen.includes(id)) {
            TooltipOpen.push(id);
        }
        this.setState({
            TooltipOpen: TooltipOpen,
        })
    }

    handleTooltipClose = (id) => event => {
        let TooltipOpen = this.state.TooltipOpen;
        if (TooltipOpen.includes(id)) {
            let index = TooltipOpen.indexOf(id);
            TooltipOpen.splice(index, 1);
        }
        this.setState({ TooltipOpen: TooltipOpen });
    };
    render() {
        const { classes } = this.props;
        const { permissions } = this.state;

        const columns = [
            {
                title: this.state.dictWord.published_department,
                dataIndex: 'publisher',
                sorter: true,
                width: '112px'
            }, {
                title: this.state.dictWord.responsible_person,
                dataIndex: 'responsibilityPerson',
                sorter: true,
                width: '116px'
            }, {
                title: this.state.dictWord.published_user,
                dataIndex: 'author',
                sorter: true,
                width: '104px'
            },
            {
                title: this.state.dictWord.category,
                dataIndex: 'categoryDepth1Name',
                width: '180px',
                toolTipDisabled: false,
                render: (text, record) => {
                    let arr = [];
                    for (let i = 1; i <= 5; i++) {
                        if (record['categoryDepth' + i + 'Name']) {
                            arr.push(record['categoryDepth' + i + 'Name']);
                        }
                    }
                    let lastName = arr.length > 0 ? arr.pop() : '';
                    let category = <span className={classes.link}>{lastName}</span>;
                    if (arr.length > 0) {
                        category = <ClickAwayListener onClickAway={this.handleTooltipClose(record.id)}>
                            <Tooltip
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                onClose={this.handleTooltipClose(record.id)}
                                open={this.state.TooltipOpen.includes(record.id)}
                                classes={{ tooltip: classes.tip }}
                                placement="top"
                                title={<MenuList>
                                    {arr.map((item, index) => {
                                        return <MenuItem key={index} style={{ marginLeft: 40 * index }} className={classes.item}><span>{item}</span></MenuItem>;
                                    })}
                                </MenuList>}
                            >
                                <span className={classes.link} onClick={this.handleTooltipOpens(record.id)}>{lastName}</span>
                            </Tooltip></ClickAwayListener>
                    }
                    return category;
                }
            },
            {
                title: this.state.dictWord.upload_date,
                dataIndex: 'updateDate',
                sorter: true,
                width: '80px',
                render: (date, fmt) => {
                    return dateFormat(new Date(date), 'yyyy/MM/dd hh:mm:ss');
                }
            }
        ]

        if (permissions.includes(8)) {
            columns.push({
                title: this.state.dictWord.management,
                key: 'action',
                width: '250px',
                toolTipDisabled: false,
                render: (text, record) => (
                    <span>
                        <Button variant="contained" color="primary" onClick={this.goto.bind(this, record)} className={classes.margin}>{this.state.dictWord.content_add}</Button>
                        <Button variant="contained" color="primary" href={'/admin.html#/admin/content/contentuseredit/' + record.id} className={classes.margin}>{this.state.dictWord.reader_edit}</Button>
                    </span>
                )
            });
        }
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={8}>
                        {permissions.includes(8) ? <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/content/contenttake'}>
                            {this.state.dictWord.application_import}
                        </Button> : null}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomizedSearchInput onClick={this.handleSearch.bind(this)} />
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
            </div>
        );
    }
}

Content_Read.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content_Read);